import { motion } from 'framer-motion';

/* ═══════════════════════════════════════════
   EDITABLE: Partner companies
   - Edit name and logoUrl for each partner
═══════════════════════════════════════════ */
const partners = [
  { name: 'NJ Investments', logoUrl: 'https://customer-assets.emergentagent.com/job_financial-evolution-1/artifacts/t8rdksz7_1.%20NJ%20Investments.png' },
  { name: 'Funds India Pvt Ltd.', logoUrl: 'https://customer-assets.emergentagent.com/job_financial-evolution-1/artifacts/8xy2u2bi_2.%20Funds%20India.jpg' },
  { name: 'HDFC ERGO', logoUrl: 'https://customer-assets.emergentagent.com/job_financial-evolution-1/artifacts/y254uo7t_3.%20HDFC%20ERGO.png' },
  { name: 'HDFC Life', logoUrl: 'https://customer-assets.emergentagent.com/job_financial-evolution-1/artifacts/724d6vm9_4.%20HDFC%20Life.jpg' },
  { name: 'Bajaj Alliance', logoUrl: 'https://customer-assets.emergentagent.com/job_financial-evolution-1/artifacts/v3dxbq47_5.%20HDFC%20Life.jpg' },
  { name: 'Manipal Sigma', logoUrl: 'https://customer-assets.emergentagent.com/job_financial-evolution-1/artifacts/zina0xk9_6.%20Manipal%20Sigma.jfif' },
  { name: 'National Insurance Co.', logoUrl: 'https://customer-assets.emergentagent.com/job_financial-evolution-1/artifacts/4x7ps86w_7.%20The%20National%20Insurance%20Company%20Limited.jfif' },
  { name: 'Tata AIG', logoUrl: 'https://customer-assets.emergentagent.com/job_financial-evolution-1/artifacts/wv8dxkxy_8.%20Tata%20AIG%20General%20Insurance.png' },
  { name: 'ASEGO', logoUrl: 'https://customer-assets.emergentagent.com/job_financial-evolution-1/artifacts/1vuyqtps_9.%20ASEGO.avif' },
  { name: 'Nuvama', logoUrl: 'https://customer-assets.emergentagent.com/job_financial-evolution-1/artifacts/wuzb2kto_10.%20Nuvama%20Wealth%20Management.jpg' },
];

export const PartnersSection = () => {
  const doubled = [...partners, ...partners];

  return (
    <section data-testid="partners-section" className="py-16 md:py-24 bg-[#F8F9FA] overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="font-['Playfair_Display'] text-2xl sm:text-3xl font-bold text-[#0A192F] mb-3">
            We Are Associated With
          </h2>
          <p className="text-sm text-[#49566B] font-['Outfit']">
            Satisfied investors for the past 30 years — proudly managing the financial needs of 5,000+ families
          </p>
        </motion.div>
      </div>

      {/* Scrolling Marquee */}
      <div className="relative">
        <div className="flex animate-marquee">
          {doubled.map((partner, index) => (
            <div
              key={`${partner.name}-${index}`}
              data-testid={`partner-${index}`}
              className="flex-shrink-0 mx-4 flex flex-col items-center justify-center bg-white rounded-xl px-8 py-6 shadow-sm min-w-[160px] hover:shadow-md transition-shadow"
            >
              {partner.logoUrl ? (
                <img src={partner.logoUrl} alt={partner.name} className="h-16 w-auto object-contain mb-2" />
              ) : (
                <div className="w-14 h-14 bg-[#0A192F] rounded-full flex items-center justify-center mb-2">
                  <span className="text-[#D4AF37] font-bold text-lg font-['Playfair_Display']">
                    {partner.name.charAt(0)}
                  </span>
                </div>
              )}
              <span className="text-xs font-semibold text-[#0A192F] font-['Outfit'] text-center leading-tight">
                {partner.name}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
